import React, { FC, useState } from 'react'

import styled from 'styled-components'

import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { PremiumCheckbox } from '../PremiumCheckbox'
import { PrimaryDottedButton } from '../Buttons/PrimaryDottedButton'

type FiltersPlatformData = {
  [CampaignPlatformTypeEnum.SPOTIFY]: boolean
  [CampaignPlatformTypeEnum.TIKTOK]: boolean
  [CampaignPlatformTypeEnum.META]: boolean
}

interface FilterByPlatformContentProps {
  filterState: FiltersPlatformData
  onApplyFilters: (data: FiltersPlatformData) => void
}

const Wrapper = styled.div`
  display: flex;
  width: 240px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
`

const Title = styled.div`
  display: flex;
  height: 40px;
  padding: 0px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const StyledButton = styled(PrimaryDottedButton)`
  margin-left: auto;
  margin-right: auto;
`
export const FilterByPlatformContent: FC<FilterByPlatformContentProps> = (
  props,
) => {
  const { onApplyFilters, filterState } = props
  const [state, setState] = useState(filterState)
  const handleApply = (): void => {
    onApplyFilters(state)
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setState((prev) => ({
      ...prev,
      [e.target.name as CampaignPlatformTypeEnum]: e.target.checked,
    }))
  }
  return (
    <Wrapper>
      <Title>Platforms</Title>
      <PremiumCheckbox
        checked={state[CampaignPlatformTypeEnum.SPOTIFY]}
        name={CampaignPlatformTypeEnum.SPOTIFY}
        onChange={onChange}
      >
        Spotify
      </PremiumCheckbox>
      <PremiumCheckbox
        checked={state[CampaignPlatformTypeEnum.TIKTOK]}
        name={CampaignPlatformTypeEnum.TIKTOK}
        onChange={onChange}
      >
        Tiktok
      </PremiumCheckbox>

      <PremiumCheckbox
        checked={state[CampaignPlatformTypeEnum.META]}
        name={CampaignPlatformTypeEnum.META}
        onChange={onChange}
      >
        Meta Ads
      </PremiumCheckbox>
      <StyledButton onClick={handleApply}>Apply</StyledButton>
    </Wrapper>
  )
}
